'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { initializePostHogClient } from '@/utils/posthogClient'

export default function PostHogProvider() {
  const pathname = usePathname()

  useEffect(() => {
    void initializePostHogClient({
      forceSessionRecording: shouldForceSessionRecording(pathname),
    })
  }, [pathname])

  return null
}

export function shouldForceSessionRecording(pathname = '') {
  const path = String(pathname || '')
  if (path.startsWith('/api')) return false
  if (path.startsWith('/admin')) return false
  if (path.startsWith('/logout')) return false

  return true
}
